import { render, staticRenderFns } from "./CategoryChips.vue?vue&type=template&id=705a4c6f&scoped=true&"
import script from "./CategoryChips.vue?vue&type=script&lang=js&"
export * from "./CategoryChips.vue?vue&type=script&lang=js&"
import style0 from "./CategoryChips.vue?vue&type=style&index=0&id=705a4c6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a4c6f",
  null
  
)

export default component.exports